<div class="header">
    <span> Quotation</span>
    <span class="desc">Create, Review and Send Quote seamlessly.</span>
</div>
<button matTooltip="Download Quote" matTooltipPosition="left" class="editRequest downloadQuoteBtn" mat-icon-button
    *ngIf="requestService.selectedRequest?.status?.dev_name!='accepted_by_internal_user' && requestService.selectedRequest?.status?.dev_name!='received'"
    (click)="downloadQuote(leaseQuoteService.baseQuote)">
    <i class="flaticon-download"></i>
</button>

<ng-container *ngIf="isQuotation">
    <ng-container>
        <div class="container">
            <div class="labelSet" fxFlex="30">
                <span class="titleL">Commercials</span>
                <span class="label">Quantity*</span>
                <span class="label">Condition*</span>
                <span class="label">Leasing Period*</span>
                <span class="label">On Hire Locations*</span>
                <span class="label">Off-Hire Locations*</span>
                <span class="label">Per Diem Charge* <i
                        matTooltip="Specify the daily rental cost for each type of container you offer."
                        matTooltipPosition="right" class="flaticon-message"></i></span>
                <span class="label">Build up Period <i
                        matTooltip="Define the build-up period clearly, including how many days or weeks the lessor has to prepare and make containers ready for the lessee."
                        matTooltipPosition="right" class="flaticon-message"></i></span>
                <span class="label">Build down Period* <i
                        matTooltip="Set a clear deadline for when leased containers need to be returned after the end of the lease agreement. This duration can vary depending on the terms of the lease."
                        matTooltipPosition="right" class="flaticon-message"></i></span>
                <span class="label"
                    matTooltip="If there's a period after the build-down where containers are returned to their original state, specify the rental charges during this time, if applicable. This could be a different rate than the initial rental period."
                      matTooltipPosition="right">Rate after build down period*</span>
                <span class="label">Minimum Rental Period* <i
                        matTooltip="Define the minimum duration for leasing containers. For example, this could be six months, or a longer period. This helps customers understand their commitments."
                        matTooltipPosition="right" class="flaticon-message"></i></span>
                <span class="label" matTooltip="	Clearly outline the terms and conditions for early returns. Update   fees associated with early returns
                " matTooltipPosition="right">Early Return Option</span>
                <span class="label"
                    matTooltip="Specify the market value or replacement value of the container. This information can be crucial for insurance purposes and in case of damage or loss."
                    matTooltipPosition="right">New Build Price*</span>
                <span class="label">Depreciation Percentage* <i
                        matTooltip="Provide information about the yearly depreciation rate used to calculate the decreased value of containers over time. This can help lessees understand the potential value of their leased assets."
                        matTooltipPosition="right" class="flaticon-message"></i></span>
                <span class="label"> Discounted Residual Value*<i
                        matTooltip="Set a discounted residual value beyond which containers should be replaced or undergo significant maintenance or refurbishment."
                        matTooltipPosition="right" class="flaticon-message"></i></span>
                <span class="label addAdHoc" *ngIf="nonConsolidatedQuoteCharges.length != 0"
                      (click)="addQuoteItemCharge(quoteList)" matTooltip="Add new Additional Charge"
                      matTooltipPosition="right" matTooltipHideDelay="2000"> Additional Charges +
                    <!-- <button mat-icon-button class=" addBtn " > +
                    </button> -->
                </span>
                <ng-container *ngIf="leaseQuoteService?.baseQuote?.quote_items[0].ad_hoc_charges?.length > 0">
                    <span *ngIf="nonConsolidatedQuoteCharges.length != 0" style="padding: 5px 0 0 0;">
                        <div class="valueSet">
                            <ng-container *ngFor="let quote of quoteList; let i = index">
                                <ng-container *ngIf="i == 0">
                                    <div class="gap-2 align-items-center"
                                        *ngFor="let charge of quote.ad_hoc_charges, let i=index">
                                        <app-mat-auto-search [isEditable]="true" [(ngModel)]="charge.quote_charge"
                                            [placeholder]="'Charge Type*'" fxFlex="14em" fxLayout="column"
                                            [idField]="null" [name]="'charge'+i" [options]="nonConsolidatedQuoteCharges"
                                            [trim]="true" [searchable]="true" [labelItemTemplate]="userSelectedItem"
                                            [itemTemplate]="userItem"
                                            class="align-items-center labelInput"></app-mat-auto-search>
                                        <i class="flaticon-delete" (click)="removeQuoteItemCharge(quoteList, i)"
                                            matTooltip="Delete" matTooltipPosition="below"
                                            matTooltipHideDelay="2000"></i>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                    </span>
                </ng-container>
                <span class="label">Container Lost After <i
                        matTooltip="Establish a clear procedure for considering containers as 'lost' if they aren't returned within a specified grace period beyond the agreed return date."
                        matTooltipPosition="right" class="flaticon-message"></i></span>
                <span class="label"
                    matTooltip="Define how much advance notice is required from either party (lessor or lessee) when there are changes to the planned delivery schedule. This ensures that both parties can prepare accordingly."
                    matTooltipPosition="right">Delivery Schedule Notice Period</span>
                <span class="label"
                    matTooltip="Similarly, specify the required notice period for any changes in the return schedule. This allows for smooth logistics planning and minimizes disruptions."
                    matTooltipPosition="right">Return Schedule Amendment</span>
                <span class="label">Quote Valid Till*</span>
                <span class="label">Quote Remarks</span>
                <!-- <span class="label" *ngIf="nonConsolidatedQuoteCharges.length != 0">
                    <button mat-raised-button class="clickIt addBtn sleekBtn addReq" (click)="addQuoteItemCharge(quoteList)"
                        matTooltip="Add new Additional Charge" matTooltipPosition="right"
                        matTooltipHideDelay="2000">Additional Charges +</button>
                </span> -->
                <!-- <span *ngIf="nonConsolidatedQuoteCharges.length != 0">
                    <div class="valueSet">
                        <ng-container *ngFor="let quote of quoteList; let i = index">
                            <ng-container *ngIf="i == 0">
                                <div class="gap-1 align-items-center"
                                    *ngFor="let charge of quote.ad_hoc_charges, let i=index">
                                    <app-mat-auto-search [isEditable]="true" [(ngModel)]="charge.quote_charge"
                                        [placeholder]="'Charge Type*'" fxFlex="14em" fxLayout="column" [idField]="null"
                                        [name]="'charge'+i" [options]="nonConsolidatedQuoteCharges" [trim]="true"
                                        [searchable]="true" [labelItemTemplate]="userSelectedItem"
                                        [itemTemplate]="userItem"
                                        class="align-items-center labelInput"></app-mat-auto-search>
                                    <i class="flaticon-delete" (click)="removeQuoteItemCharge(quoteList, i)"
                                        matTooltip="Delete" matTooltipPosition="below" matTooltipHideDelay="2000"></i>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </span> -->
            </div>
            <div fxFlex="67" class="valueSetBox">
                <div class="valueSet" fxFlex="14.7em"
                    *ngFor="let quote of quoteList | orderRequirements: 'container_size_type':'display':'asc'; let i = index">
                    <span class="valueSetTitle">{{ quote.container_size_type?.display }}</span>
                    <app-number-field [isEditable]="negotiate" [placeholder]="'Quantity'" class="w-100i"
                        [(ngModel)]="quote.quantity" [containerNum]="true" [noDecimal]="true" [maxlength]="4"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].quantity" [minValue]="1">
                    </app-number-field>
                    <app-mat-auto-search [isEditable]="negotiate" [displayField]="'value'" [name]="'name'"
                        [(ngModel)]="quote.container_condition" [idField]="null" [listUrl]="containerConditionLists"
                        [setSearchValue]="false" class="w-100i"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].container_condition">
                    </app-mat-auto-search>
                    <logzy-duration-field [isEditable]="negotiate" [(days)]="quote.leasing_period_days" class="w-100i"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].leasing_period_days"
                        [(ngModel)]="quote.leasing_period_days" (ngModelChange)="setLeaseDuration($event)"
                        fxLayout="column" [minValue]="1" [maxValue]="9999">
                    </logzy-duration-field>
                    <app-mat-auto-search [(ngModel)]="quote.pol_list"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].pol_list" [isEditable]="negotiate"
                        [idField]="null" displayField='name_display' [trim]="true" [multiple]="true"
                        [defaultChip]="false" [clearable]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true"
                        [listUrl]="location_url" name="pods" fxLayout="column" class="w-100i locations">
                    </app-mat-auto-search>
                    <app-mat-auto-search [(ngModel)]="quote.pod_list"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].pod_list" [isEditable]="negotiate"
                        [idField]="null" displayField='name_display' [trim]="true" [multiple]="true"
                        [defaultChip]="false" [clearable]="true" [closeOnSelect]="false" [clearSearchOnAdd]="true"
                        [listUrl]="location_url" name="pods" fxLayout="column" class="w-100i locations">
                    </app-mat-auto-search>
                    <logzy-money-field [isEditable]="negotiate" [(amount)]="quote.per_diem_charge" [minValue]="0"
                        [(currencyCode)]="quote.per_diem_charge_currency" class="w-100i" [maxValue]="999999999"
                        [maxlength]="5" [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].per_diem_charge">
                    </logzy-money-field>
                    <logzy-duration-field [isEditable]="negotiate" [(days)]="quote.build_up_period_days" class="w-100i"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].build_up_period_days"
                        [maxlength]="3" [minValue]="1" [maxValue]="9999">
                    </logzy-duration-field>
                    <logzy-duration-field [isEditable]="negotiate" [(days)]="quote.build_down_period_days"
                        class="w-100i" [minValue]="0" [maxValue]="9999" [maxlength]="3"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].build_down_period_days">
                    </logzy-duration-field>
                    <logzy-money-field [isEditable]="negotiate" [(amount)]="quote.post_build_down_per_diem_charge"
                        [minValue]="0" [maxValue]="999999999"
                        [(currencyCode)]="quote.post_build_down_per_diem_charge_currency" class="w-100i"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].post_build_down_per_diem_charge">
                    </logzy-money-field>
                    <logzy-duration-field [isEditable]="negotiate" [(days)]="quote.minimum_rental_period_days"
                        class="w-100i" [minValue]="1" [maxValue]="9999"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].minimum_rental_period_days"
                        [maxValue]="quote.leasing_period_days">
                    </logzy-duration-field>
                    <div class="earlyReturnOption">
                        <app-toggle-select class="inputToggle" [isEditable]="negotiate"
                            [disabled]="agreementCurrency == null || isCustomer" [(ngModel)]="quote.is_ero_enabled"
                            (click)="toogleReturnOption(quote.is_ero_enabled, quote)" [name]="'ero'"
                            [displayField]="'value'" [options]="earlyReturnOption" fxLayout="column"
                            [errors]="errorObj.ero" class="align-items-center">
                        </app-toggle-select>
                        <button class="eroBtn sleekBtn Save"
                            *ngIf="quote.ero?.length != 0 && quote.is_ero_enabled?.code == true" mat-raised-button
                            (click)="viewEroDetails(quote)">
                            View
                        </button>
                    </div>
                    <logzy-money-field [isEditable]="negotiate" [(amount)]="quote.drv_new_build_price" [minValue]="0"
                        [(currencyCode)]="quote.drv_new_build_price_currency" class="w-100i" [maxValue]="999999999"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].drv_new_build_price">
                    </logzy-money-field>
                    <app-percent-field [isEditable]="negotiate" [placeholder]="'Depreciation '" class="w-100i"
                        [(ngModel)]="quote.drv_depreciation_per_year" fxLayout="column"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].drv_depreciation_per_year">
                    </app-percent-field>

                    <!-- here to add new field -->
                    <!-- <logzy-multi-field [isEditable]="negotiate" [placeholder]="'Discounted Residual Value'"
                        [(amount)]="quote.drv_max_depreciation_price"
                        [(currencyCode)]="quote.drv_max_depreciation_price_currency"
                        [(percent)]="quote.drv_max_depreciation_percent" (selectFieldChange)="selectChoice($event,i)"
                        fxLayout="column" class="w-100i"
                        [(errors)]="leaseQuoteService.baseQuote.error.quote_items[i].drv_max_depreciation_percent">
                    </logzy-multi-field> -->
                    <logzy-multi-field [isEditable]="negotiate" [placeholder]="'Discounted Residual Value'"
                        [(amount)]="quote.drv_max_depreciation_price"
                        [(currencyCode)]="quote.drv_max_depreciation_price_currency"
                        [(percent)]="quote.drv_max_depreciation_percent" [selectField]="quote.drv_max_depreciation_unit"
                        (selectFieldChange)="selectChoice($event,i)" fxLayout="column" class="w-100i"
                        [(errors)]="quote.drv_max_depreciation_unit == 'price' ? leaseQuoteService.baseQuote.error.quote_items[i].drv_max_depreciation_price : leaseQuoteService.baseQuote.error.quote_items[i].drv_max_depreciation_percent">
                    </logzy-multi-field>
                    <span style="height: 45px;"> &nbsp; </span>
                    <ng-container *ngIf="quote?.ad_hoc_charges?.length > 0">
                        <ng-container *ngIf="nonConsolidatedQuoteCharges.length != 0">
                            <!-- <div [class.gap-2]="tncExpand" style="justify-content: flex-start;"> -->

                            <div class=" rGap15 inputs leaseRequest">
                                <!-- <div fxFlex="100" class="leaseRequest"> -->
                                <ng-container *ngFor="let charge of quote.ad_hoc_charges, let i=index">
                                    <!-- <div fxFlex="100" fxLayout="column"> -->
                                    <logzy-money-field [isEditable]="true" [(amount)]="charge.amount" fxFlex="100"
                                        fxLayout="column" [maxValue]="999999999"
                                        [(currencyCode)]="charge.amount_currency" [(errors)]="charge?.error.amount">
                                    </logzy-money-field>
                                    <!-- </div> -->
                                </ng-container>
                                <!-- </div> -->
                            </div>
                            <!-- </div> -->
                        </ng-container>
                    </ng-container>
                    <!-- <app-percent-field [isEditable]="negotiate" [placeholder]="'Discounted Residual Value '" class="w-100i"
                        [(ngModel)]="quote.drv_max_depreciation_percent" fxLayout="column"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].drv_max_depreciation_percent">
                    </app-percent-field> -->
                    <logzy-duration-field [isEditable]="negotiate" [class.hidden]="i!=0" [disabled]="i!=0"
                        [(days)]="quote.container_deemed_lost_after_days" class="w-100i" [minValue]="1"
                        [maxValue]="9999" [maxlength]="4"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].container_deemed_lost_after_days">
                    </logzy-duration-field>
                    <logzy-duration-field [isEditable]="negotiate" [class.hidden]="i!=0" [disabled]="i!=0"
                        [(days)]="quote.notice_period_amendment_delivery_days" class="w-100i" [minValue]="1"
                        [maxValue]="9999" [maxlength]="4"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].notice_period_amendment_delivery_days">
                    </logzy-duration-field>
                    <logzy-duration-field [isEditable]="negotiate" [class.hidden]="i!=0" [disabled]="i!=0"
                        [(days)]="quote.notice_period_amendment_return_days" class="w-100i" [minValue]="1"
                        [maxValue]="9999" [maxlength]="4"
                        [(errors)]="leaseQuoteService.baseQuote.error?.quote_items[i].notice_period_amendment_return_days">
                    </logzy-duration-field>
                    <app-date-field [isEditable]="negotiate" [(ngModel)]="leaseQuoteService.baseQuote.quote_valid_till"
                        [class.hidden]="i!=0" [disabled]="i!=0"
                        [(errors)]="leaseQuoteService.baseQuote.error.quote_valid_till" [minDate]="currentDate"
                        class="w-100i" fxLayout="column"></app-date-field>
                    <app-text-field [isMultiline]="true" [isEditable]="negotiate" [class.hidden]="i!=0"
                        [disabled]="i!=0" class="w-100i" fxLayout="column"
                        [(ngModel)]="leaseQuoteService.baseQuote.remarks" [name]="'remarks'"
                        [(errors)]="leaseQuoteService.baseQuote.error.remarks">
                    </app-text-field>
                    <!-- <ng-container *ngIf="nonConsolidatedQuoteCharges.length != 0">
                        <div class="vstack " [class.gap-2]="tncExpand">
                            <div style="justify-content: flex-start; margin-top: 50%;">
                                <div fxFlex="100" class="inputs">
                                    <div fxFlex="100" class="leaseRequest">
                                        <div *ngFor="let charge of quote.ad_hoc_charges, let i=index">
                                            <logzy-money-field [isEditable]="true" [(amount)]="charge.amount"
                                                fxFlex="100" fxLayout="column" [maxValue]="999999999"
                                                [(currencyCode)]="charge.amount_currency"
                                                [(errors)]="charge?.error.amount">
                                            </logzy-money-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container> -->
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="consolidatedQuoteCharges.length != 0">
        <div class="vstack " [class.gap-2]="tncExpand">
            <div class="HeaderSet">
                <span class="editHead editHeadCursor">
                    Request Quote Charges
                </span>
            </div>
            <div class="additionalDetails" style="justify-content: flex-end;" [class.viewExpand]="tncExpand">
                <button mat-raised-button class="clickIt addBtn addReq" [disabled]="!negotiate" (click)="addCharge()"
                        matTooltip="Add new Additional Charge" matTooltipPosition="left" matTooltipHideDelay="2000">+
                    Additional Charges
                </button>
                <div fxFlex="100" class="inputs">
                    <div fxFlex="100" class="leaseRequest leasebox">
                        <!-- <div > -->
                        <div class="inputs"
                            *ngFor="let charge of leaseQuoteService.baseQuote.ad_hoc_charges, let i=index">
                            <div fxFlex="15em" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Charge Type*</span>
                                </div>
                                <app-mat-auto-search [isEditable]="true" fxFlex="100" [(ngModel)]="charge.quote_charge"
                                    [idField]="null" [name]="'charge'+i" [options]="consolidatedQuoteCharges"
                                    [trim]="true" [searchable]="true" [labelItemTemplate]="userSelectedItem"
                                    [itemTemplate]="userItem" class="align-items-center"
                                    [(errors)]="charge?.error.quote_charge"></app-mat-auto-search>
                            </div>
                            <div fxFlex="15em" fxLayout="column">
                                <div class="inputTitle">
                                    <span>Amount*</span>
                                </div>
                                <div fxFlex="100">
                                    <logzy-money-field [isEditable]="true" [(amount)]="charge.amount"
                                        [maxValue]="999999999" [(currencyCode)]="charge.amount_currency"
                                        [(errors)]="charge?.error.amount">
                                    </logzy-money-field>
                                </div>
                            </div>
                            <div class="actionBtn">
                                <i class="flaticon-delete" (click)="removeCharge(i)" matTooltip="Delete"
                                    matTooltipPosition="below" matTooltipHideDelay="2000"
                                    *ngIf="leaseQuoteService.baseQuote.ad_hoc_charges.length > 0"></i>
                            </div>
                        </div>
                        <!-- </div> -->
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container>
        <div class="vstack " [class.gap-2]="pickupScheduleExpand">
            <div class="HeaderSet">
                <span class="editHead editHeadCursor" (click)="pickupScheduleExpand = !pickupScheduleExpand">
                    Pick-up Schedule
                    <i class="flaticon-down-chevron" [ngClass]="pickupScheduleExpand? 'more':'' "></i>
                </span>
            </div>
            <div class="additionalDetails" [class.viewExpand]="pickupScheduleExpand">
                <logzy-pickup-dropoff-schedule-lease [scheduleList]="scheduleList" [type]="'p'"
                    *ngIf="viewScheduleTable == true" (editPS)="editPickupSchedule($event)"
                    [quoteList]="quoteList"></logzy-pickup-dropoff-schedule-lease>
            </div>
        </div>
    </ng-container>
    <ng-container>
        <div class="vstack " [class.gap-2]="dropoffScheduleExpand">
            <div class="HeaderSet">
                <span class="editHead editHeadCursor" (click)="dropoffScheduleExpand = !dropoffScheduleExpand">
                    Drop-off Schedule
                    <i class="flaticon-down-chevron" [ngClass]="dropoffScheduleExpand? 'more':'' "></i>
                </span>
            </div>
            <div class="additionalDetails" [class.viewExpand]="dropoffScheduleExpand">
                <logzy-pickup-dropoff-schedule-lease [scheduleList]="scheduleList" [type]="'d'"
                    *ngIf="viewScheduleTable == true" (editDS)="editDropoffSchedule($event)"
                    [quoteList]="quoteList"></logzy-pickup-dropoff-schedule-lease>
            </div>
        </div>
    </ng-container>
    <ng-container>
        <div class="vstack " [class.gap-2]="tncExpand">
            <div class="HeaderSet">
                <span class="editHead editHeadCursor">
                    Terms and Conditions
                </span>
            </div>
            <div class="additionalDetails " [class.viewExpand]="tncExpand">
                <app-select-field [isEditable]="!isCustomer && negotiate"
                    [hidden]="isCustomer || termsConditionList?.length == 1" [name]="'termsCondition'"
                    [displayField]="'name'" [(ngModel)]="termsAndCondition" [options]="termsConditionList"
                    fxLayout="column" fxFlex="12em" (ngModelChange)="showSelectedTermsAndCondition()"
                    [(errors)]="leaseQuoteService.baseQuote.error.terms_and_condition_fk">
                </app-select-field>
                <quill-editor *ngIf="!isCustomer" [styles]="{'min-height': '50px'}"
                    [(ngModel)]="selectedTermsAndCondition" id="termsAndCondition" [modules]="modules" #editor
                    placeholder="Enter Terms and Conditions ....." style="width: inherit;">
                </quill-editor>
                <quill-view *ngIf="isCustomer" [content]="selectedTermsAndCondition" format="html" theme="snow"
                    style="overflow: auto;     border: 1px solid #d5d5d5;  width: 100%;"></quill-view>
            </div>
        </div>
    </ng-container>
    <ng-container>
        <div fxFlex="100" class="btnb" fxLayout="row wrap"
            *ngIf="requestService.selectedRequest?.status?.dev_name != 'quote_accepted_by_external_user'">
            <!-- <button *ngIf="!isCustomer" class="loadingBtn Save" mat-raised-button (click)="editRequest(quoteList)">
                <span>Add/View Partner Details</span>
            </button> -->
            <button *ngIf="isCustomer" class="loadingBtn Save" mat-raised-button
                [disabled]="disableSaveButton || !negotiate" (click)="cancelQuoteEditing()">
                <span>Cancel</span>
            </button>
            <button *ngIf="!isCustomer" class="loadingBtn Save" mat-raised-button (click)="reviewQuote('review')">
                <span>Review Quote</span>
            </button>
            <button class="loadingBtn Save" mat-raised-button [disabled]="disableSaveButton || !negotiate"
                (click)="saveQuotation()">
                <span *ngIf="!disableSaveButton">{{isCustomer ? 'Save Negotiation' : 'Save Quotation'}}</span>
                <div *ngIf="disableSaveButton" class="p03">
                    <i class="flaticon-loading spin"></i>
                    <span>Saving...</span>
                </div>
            </button>
        </div>
    </ng-container>
    <ng-container>
        <div class="vstack " [class.gap-2]="uploadDocExpand">
            <div class="HeaderSet">
                <span class="editHead editHeadCursor" (click)="uploadDocExpand = !uploadDocExpand">
                    Comments/Attachments
                    <i class="flaticon-down-chevron" [ngClass]="uploadDocExpand? 'more':'' "></i>
                </span>
            </div>
            <div class="additionalDetails" [class.viewExpand]="uploadDocExpand">
                <mat-tab-group animationDuration="1500ms">
                    <mat-tab label="Comments">
                        <div class="additionalDetails" [class.viewExpand]="remarkExpand">
                            <logzy-quote-remarks fxLayout="row wrap">
                            </logzy-quote-remarks>
                        </div>
                    </mat-tab>
                    <mat-tab label="Attachments">
                        <div class="mnrList">
                            <logzy-request-documents fxFlex="100"></logzy-request-documents>
                            <!-- <ng-container>
                                <app-mat-auto-search [isEditable]="true" [label]="'Document Type*'"
                                    *ngIf="negotiate" [class.marginb-9]="!showUpload"
                                    [(ngModel)]="selectedDocument" [displayField]="'name'" [name]="'name'"
                                    [defaultChip]="false" [idField]="null" [options]="documentTypeList"
                                    [setSearchValue]="false" fxFlex="17em" fxLayout="column" [clearable]=true
                                    (change)="showDocumentUpload($event)">
                                </app-mat-auto-search>
                                <div class="choose" fxFlex="100" fxLayout="column" *ngIf="showUpload">
                                    <app-file-field [isEditable]="true" [fileDropArea]="true" [showUploadedList]="true"
                                        fxLayout="row" class="fileDrop dmgDrop"
                                        [(ngModel)]="leaseQuoteService.baseQuote.uploaded_documents"
                                        [documentTypeDevName]="selectedDocumentType" [name]="selectedDocumentType">
                                    </app-file-field>
                                </div>
                            </ng-container> -->
                        </div>
                        <!-- <button mat-raised-button class="loadingBtn Save" (click)="saveLeaseAgreementDocandTnc()">Upload
                            Documents</button> -->
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </ng-container>
</ng-container>

<ng-template #userItem let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{item?.charge?.print_name}}
        </span>
        <span class="email">
            {{item?.charge?.charge_code}}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItem let-item>
    {{item?.charge?.print_name}}
</ng-template>
